import { ESPage, useDocumentTitle } from '@energy-stacks/shared';
import { useTranslation } from 'react-i18next';
import { TMHDashboard } from './TMHDashboard';

export const TMHDashboardPage = () => {
  const { t } = useTranslation('dashboard');
  useDocumentTitle(t('title'));

  return (
    <ESPage title={t('title')}>
      <TMHDashboard />
    </ESPage>
  );
};
